<template>
  <div class="relative">
    <main-header />
    <vue-progress-bar></vue-progress-bar>
    <v-main>
      <v-container class="v-xl-container">
        <slot />
      </v-container>
    </v-main>
    <!--<main-footer />-->
  </div>
</template>

<script>
  import MainHeader from '@/components/layout/MainHeader.vue'
  // import MainFooter from '@/components/layout/MainFooter.vue'

  export default {
    components: {
      MainHeader
      // MainFooter
    }
  }
</script>
